import { BaseClient } from '../client';
import { DealerMock } from './dealer.mocks';
import { TConcessionaria } from './dealer.types';

interface getDealerByIdProps {
	id: string;
}

export const getDealerById = async ({ id }: getDealerByIdProps) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return DealerMock;
	// }

	try {
		const response = await BaseClient.get<TConcessionaria[]>(`/Concessionarias/${id}`).then(
			(response) => response.data
		);

		return response.at(0);
	} catch (error) {
		console.error(error);
	}
};
